import { render, staticRenderFns } from "./AudioLibrary.vue?vue&type=template&id=ae1c3c2a&scoped=true"
import script from "./AudioLibrary.vue?vue&type=script&lang=js"
export * from "./AudioLibrary.vue?vue&type=script&lang=js"
import style0 from "./AudioLibrary.vue?vue&type=style&index=0&id=ae1c3c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1c3c2a",
  null
  
)

export default component.exports